<div class="min-h-screen bg-gradient-to-br from-slate-50 to-blue-50">
  <div class="container mx-auto px-4 py-8">

    <div class="mb-8">
      <div class="flex items-center mb-4">
        <div class="bg-gradient-to-r from-blue-500 to-indigo-600 p-3 rounded-xl shadow-lg mr-4">
          <svg class="w-8 h-8 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 19v-6a2 2 0 00-2-2H5a2 2 0 00-2 2v6a2 2 0 002 2h2a2 2 0 002-2zm0 0V9a2 2 0 012-2h2a2 2 0 012 2v10m-6 0a2 2 0 002 2h2a2 2 0 002-2m0 0V5a2 2 0 012-2h2a2 2 0 012 2v14a2 2 0 01-2 2h-2a2 2 0 01-2-2z"></path>
          </svg>
        </div>
        <div>
          <h1 class="text-4xl font-bold bg-gradient-to-r from-gray-800 to-gray-600 bg-clip-text text-transparent">
            Reporte Detalle del Programa
          </h1>
          <p class="text-gray-600 mt-1">Genera el detalle de ingresos y egresos por categoría y subcategoría</p>
        </div>
      </div>
    </div>

    <div class="bg-white rounded-2xl shadow-xl border border-gray-100 overflow-hidden">
      <div class="bg-gradient-to-r from-blue-50 to-indigo-50 border-b border-gray-100 p-6">
        <h2 class="text-xl font-semibold text-gray-800 flex items-center">
          <svg class="w-5 h-5 mr-2 text-blue-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 19V9a2 2 0 012-2h2a2 2 0 012 2v10" />
          </svg>
          Configuración del Reporte
        </h2>
        <p class="text-gray-600 text-sm mt-1">Seleccione el proyecto para generar el reporte</p>
      </div>

      <div class="p-6">
        <form [formGroup]="reportForm" (ngSubmit)="downloadExcelReport()">
          <div class="grid grid-cols-1 md:grid-cols-3 gap-6 mb-8">
            <div class="space-y-2">
              <label for="project" class="block text-sm font-semibold text-gray-700">Proyecto *</label>
              <p-dropdown
                id="project"
                formControlName="projectId"
                [options]="projectsDropdown"
                [showClear]="true"
                [filter]="true"
                placeholder="Seleccionar proyecto"
                optionLabel="label"
                optionValue="value"
                class="w-full custom-dropdown">
              </p-dropdown>
              <div *ngIf="reportForm.get('projectId')?.invalid && reportForm.get('projectId')?.touched" class="text-red-500 text-xs mt-1">
                Este campo es requerido
              </div>
            </div>
          </div>

          <div class="bg-gray-50 rounded-lg p-4 mb-6">
            <h3 class="text-lg font-semibold text-gray-800 mb-2">Selección Actual:</h3>
            <div class="grid grid-cols-1 md:grid-cols-3 gap-4 text-sm">
              <div>
                <span class="font-medium text-gray-600">Proyecto:</span>
                <span class="ml-2 text-gray-800">{{ selectedProjectName }}</span>
              </div>
              <div>
                <span class="font-medium text-gray-600">Tipo:</span>
                <span class="ml-2 text-blue-600 font-medium">Detalle del Programa</span>
              </div>
            </div>
          </div>

          <div class="flex flex-col sm:flex-row justify-end gap-4">
            <button
              type="submit"
              [disabled]="reportForm.invalid || loading"
              class="px-8 py-3 bg-gradient-to-r from-blue-600 to-indigo-600 text-white font-semibold rounded-xl shadow-lg hover:from-blue-700 hover:to-indigo-700 transform hover:scale-105 transition-all duration-200 disabled:opacity-50 disabled:cursor-not-allowed disabled:transform-none flex items-center justify-center min-w-[200px]">
              <div *ngIf="loading" class="flex items-center">
                <div class="animate-spin rounded-full h-4 w-4 border-b-2 border-white mr-3"></div>
                <span>Generando Excel...</span>
              </div>
              <div *ngIf="!loading" class="flex items-center">
                <svg class="w-5 h-5 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 10v6m0 0l-3-3m3 3l3-3M3 17V7a2 2 0 012-2h6l2 2h6a2 2 0 012 2v8a2 2 0 01-2 2H5a2 2 0 01-2-2z"></path>
                </svg>
                <span>Descargar Excel</span>
              </div>
            </button>
          </div>
        </form>
      </div>
    </div>

    <!-- My Reports Section -->
    <app-recent-report-jobs></app-recent-report-jobs>

    <div class="mt-8 bg-white rounded-xl shadow-sm border border-gray-100 p-6">
      <div class="flex items-start">
        <div class="flex-shrink-0">
          <svg class="w-6 h-6 text-blue-500 mt-0.5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"></path>
          </svg>
        </div>
        <div class="ml-4">
          <h4 class="text-lg font-medium text-gray-800">Información del Reporte</h4>
          <div class="mt-2 text-sm text-gray-600 space-y-1">
            <p>• Incluye KPIs de inscripciones individuales y corporativas</p>
            <p>• Ingresos y egresos clasificados por categoría y subcategoría</p>
            <p>• Exporta en Excel (.xlsx) en una sola hoja</p>
          </div>
        </div>
      </div>
    </div>

  </div>
</div>


